import { generateDummyPassword } from './db/utils';

export const isProductionEnv = process.env.NODE_ENV === 'production';
export const isDevelopmentEnv = process.env.NODE_ENV === 'development';
export const isTestEnvironment = Boolean(
  process.env.PLAYWRIGHT_TEST_BASE_URL ||
    process.env.PLAYWRIGHT ||
    process.env.CI_PLAYWRIGHT,
);

export const guestRegex = /^guest-\d+$/;

export const DUMMY_PASSWORD = generateDummyPassword();

export const KEY_SelectedIndices ='CONSTANT.selectedIndices';
export const KEY_FlowTemplateFlag ='@flow.template';
export const KEY_302ModelData='302.moddels';
export const KEY_SystemConfig = "SYSTEM_CONFIG";
export const KEY_SettingsStore = "AKLOCAL";
export const KEY_SettingsJsonStore = "AKJsonLOCAL";
export const KEY_LocalConfigTemplateName = "system@localSetting.aikeys";
